/**
 * Capacitor platform helpers.
 * Web keeps existing PWA behavior; native uses plugins.
 */
import { Capacitor } from '@capacitor/core';

export function isNative() {
  return Capacitor.isNativePlatform();
}

export function getPlatform() {
  return Capacitor.getPlatform();
}

export function isAndroid() {
  return getPlatform() === 'android';
}
